import { isCardFinished } from 'core/helpers/exercise';

import BeforePanel from '../BeforePane';
import DefinitionPane from '../DefinitionPane';
import ValuePanel from '../ValuePane';
import { TWordCardSide } from '../shared';

type TOptions = {
  flip: (event: React.SyntheticEvent | Event | undefined) => Promise<void>;
  side: TWordCardSide;
  deck: TDeck;
  word: TWord;
  disabled: boolean;
  exercise: keyof Pick<TExerciseEnum, 'wordCards' | 'wordCardsReverse'>;
};

type TResult = {
  frontPanel: React.ReactNode;
  backPanel: React.ReactNode;
};

const useDirect = ({ flip, side, word, disabled, deck }: TOptions): TResult => {
  const finished = isCardFinished(side);

  switch (side) {
    case TWordCardSide.front:
      return {
        frontPanel: (
          <BeforePanel flip={flip} disabled={disabled} lang={deck.lang} />
        ),
        backPanel: (
          <ValuePanel deck={deck} word={word} finished={true} disabled />
        ),
      };

    case TWordCardSide.back:
      return {
        frontPanel: (
          <ValuePanel
            deck={deck}
            word={word}
            finished={finished}
            disabled={disabled}
          />
        ),
        backPanel: null,
      };
  }
};

const useReverse = ({
  deck,
  flip,
  side,
  word,
  disabled,
}: TOptions): TResult => {
  const finished = isCardFinished(side);
  switch (side) {
    case TWordCardSide.front:
      return {
        frontPanel: <BeforePanel flip={flip} disabled={disabled} lang={null} />,
        backPanel: <DefinitionPane deck={deck} word={word} finished={true} />,
      };

    case TWordCardSide.back:
      return {
        frontPanel: (
          <DefinitionPane deck={deck} word={word} finished={finished} />
        ),
        backPanel: null,
      };
  }
};

export default function useSidesDetect(options: TOptions): TResult {
  switch (options.exercise) {
    case TExercise.wordCards:
      return useDirect(options);
    case TExercise.wordCardsReverse:
      return useReverse(options);
  }
}
